export default __webpack_public_path__ + "static/media/img4.4289f54d.webp";